// order-domain: ownership=kkren copyPolicy=copy-and-prune-mgb pruneAfter=brand-retirement
// 家具棧板費強制走海運（2026-09-13 王通）：海運倉的家具包裹只要有一件命中棧板費條件，整單不能走海快，
// 家具只能走海運；不可走海運的例外件沿用拆單流程另建海快單或留倉。
// 棧板費條件與費用引擎同口徑（`computeHasHctHatPalletFeeParcels`：hctCai > 10 才或重量 ≥ 70 kg，暫存包裹除外），
// 只看家具包裹、不看最終派件方式（選運輸方式時派件方式尚未選）。費用不變。
import { computeHasHctHatPalletFeeParcels } from '../fee/hctFee'
import { formatParcelNames } from '@g/order-shared/splitOrderCopy'

export const SEA_FORCED_BOTTOM_LOCK = '本單含需收棧板費的家具，請改選海運'

export function computeSeaForcedRule ({ parcels = [], jyAddrid, seaAddrids = [], enabled = true } = {}) {
  const list = Array.isArray(parcels) ? parcels : []
  const isSeaAddr = (seaAddrids || []).map(String).includes(String(jyAddrid))
  const furniture = list
    .filter(parcel => parcel?.isFurniture)
    .map(parcel => (parcel.extraInfo ? parcel : { ...parcel, extraInfo: {} }))
  const palletParcels = enabled && isSeaAddr ? computeHasHctHatPalletFeeParcels({ parcels: furniture }) : []
  return {
    forced: palletParcels.length > 0,
    isSeaAddr,
    palletParcels,
  }
}

export function buildSeaForcedCopy (rule) {
  if (!rule?.forced) {
    return { seCardText: '', seDisabledText: '', bottomLock: '' }
  }
  const text = `本單含需收棧板費的家具（${formatParcelNames(rule.palletParcels)}），家具只能走海運；不可走海運的包裹請另外下單。`
  return {
    seCardText: text,
    seDisabledText: text,
    bottomLock: SEA_FORCED_BOTTOM_LOCK,
  }
}
